<template>
  <b-row>
    <b-col md="6" cols="12">
      <b-form-group :label="label" :label-for="label">
        <v-select
          :loading="loading"
          :dir="locale === 'ar' ? 'rtl' : 'ltr'"
          :disabled="disabled"
          :multiple="multiple"
          :value="value"
          :required="required"
          :filterable="false"
          :options="transformedItems"
          :reduce="serializer"
          :label="isRelational ? undefined : textTitle"
          :placeholder="placeholder"
          @search="searchItem"
          @input="selected"
          attach
          clearable
        >
          <template v-slot:option="option">
            <slot name="option" v-bind="option"></slot>
          </template>

          <template v-slot:selected-option="option">
            <slot name="selected-option" v-bind="option"></slot>
          </template>

          <template v-slot:no-options="props">
            <slot name="no-option" v-bind="props"></slot>
          </template>
        </v-select>
        <slot name="item-select"></slot>
        <b-form-invalid-feedback :state="!errorMessages">
          <span
            v-for="(err, index) in errorMessages"
            :key="index"
            v-text="err"
          ></span>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col md="6" cols="12">
      <b-form-group :label="$t('common.amount')" label-for="amount">
        <b-form-input
          :disabled="disableAmount"
          id="amount"
          type="number"
          v-model="finalValue.price"
          :placeholder="$t('common.amount')"
        />
        <p class="text-danger mt-1">{{ ErrorAmount }}</p>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BRow,
  BCol,
} from 'bootstrap-vue';
import { debounce } from 'lodash';
import vSelect from 'vue-select';

export default {
  components: {
    vSelect,
    BFormInvalidFeedback,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
  },
  props: {
    ErrorAmount: String,
    errorMessages: Array,
    value: Object | String,
    placeholder: String,
    label: String,
    paramQuery: String,
    serializer: Function,
    required: Boolean,
    multiple: Boolean,
    textTitle: String,
    disabled: Boolean,
    otherQuery: String,
    employeeId: String,
    keyword: String,
    isRelational: Boolean,
    altSearch: String,
    disableAmount: Boolean,
  },
  data: () => ({
    items: [],
    loading: false,
    locale: localStorage.getItem('lng'),
    selection: [],
    searchValue: '',
    finalValue: '',
  }),

  watch: {
    otherQuery() {
      if (!this.disabled) {
        this.getItems().then(() => {
          if (this.value) {
            let item = this.items.find((it) => it.id === this.value.id);
            if (!item) {
              this.items.push(this.value);
              this.$emit('input', this.value);
            } else {
              this.$emit('input', item);
            }
          }
        });
      }
    },
  },
  computed: {
    transformedItems() {
      if (this.textTitle.includes('.')) {
        const beforeText = this.getWordBeforeDot(this.textTitle);
        const afterText = this.getStringAfterDot(this.textTitle);

        return this.items?.map((item) => {
          const nestedProperty = item[beforeText];
          return {
            ...item,
            label: nestedProperty ? nestedProperty[afterText] : undefined,
          };
        });
      } else {
        return this.items;
      }
    },
  },
  methods: {
    addToItems(item) {
      this.items.push(item);
    },
    getWordBeforeDot(inputString) {
      const dotIndex = inputString.indexOf('.');
      if (dotIndex !== -1) {
        return inputString.substring(0, dotIndex);
      } else {
        return ''; // Return an empty string if no dot is found
      }
    },
    getStringAfterDot(inputString) {
      const dotIndex = inputString.indexOf('.');
      if (dotIndex !== -1) {
        return inputString.substring(dotIndex + 1);
      } else {
        return ''; // Return an empty string if no dot is found
      }
    },
    selected(vals) {
      this.finalValue = vals;
      this.$emit('val', vals);
      this.$emit('input', vals);
      this.$emit('hide', false);
      this.$emit('close', false);
      this.$emit('hidden', false);
    },
    async getItems(query = '', pageSize = 5) {
      this.loading = true;
      let url = `/service?page=1&take=10&sort=-id&${`filter[${
        this.altSearch ? this.altSearch : this.textTitle
      }]=${query ?? ''}`}`;
      if (this.otherQuery) {
        url += `&${this.otherQuery}`;
      }
      if (this.isRelational) {
        url += `&filter[${this.paramQuery}]=${query ?? ''}`;
      }
      await this.getList(url);

      this.items = this.all_data.data;
      this.loading = false;
    },
    searchItem: debounce(function (query) {
      // INFO: For some reason, when the debounce function is rand after selecting an item...
      // If the item was not returned from the this.getItems() than it'll show the ID of the item instead..
      // of it's name. hence why we are passing a 500 pageSize
      this.getItems(query, 500);
    }, 500),
  },

  mounted() {
    if (!this.disabled) {
      this.getItems().then(() => {
        if (this.value) {
          let item = this.items.find((it) => it.id === this.value.id);
          if (!item) {
            this.items.push(this.value);
            this.$emit('input', this.value);
          } else {
            this.$emit('input', item);
          }
        }
      });
    }
  },
};
</script>
<style scoped>
.v-select-dropdown {
  z-index: 9999999 !important; /* Ensure it's higher than the table's z-index */
}
.dropdown-menu {
  z-index: 1050 !important; /* Use a value high enough to overlay other components */
}
</style>
